import React, { FunctionComponent, useEffect, useState, useMemo, useContext } from 'react';
import { chartColorArr } from './const';
import { article } from '@Api';
import cx from 'classnames';
import styles from './chartExtraBar.module.less';


interface IProps {
  dataSource: Array<{
    name: string;
    value: string;
  }>
}

const { fetchHotsell } = article;
const firstHeaderWidthMap = {
  'fillTable': '104px'
}


const ChartExtraBar: FunctionComponent<IProps> = ({ dataSource }) => {
  return (
    <div>
      {
        dataSource.map((item, inx) => (
          <div className={cx(styles["chart-extra-bar"])} key={inx}>
            <div className={styles['bar-left']}>
              <div className={styles['bar-color-block']} style={{ backgroundColor: chartColorArr[inx] }}></div>
              { item.name }
            </div>
            <div className={styles['bar-right']}>實測環境：{ item.value }</div>
          </div>
        ))
      }
    </div>
  )
}

export default ChartExtraBar;